var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepEventAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.83732H10.75V1.67065H9.58333V2.83732H4.91667V1.67065H3.75V2.83732H3.16667C2.525 2.83732 2 3.36232 2 4.00399V12.1707C2 12.8123 2.525 13.3373 3.16667 13.3373H11.3333C11.975 13.3373 12.5 12.8123 12.5 12.1707V4.00399C12.5 3.36232 11.975 2.83732 11.3333 2.83732ZM11.3333 12.1707H3.16667V6.33732H11.3333V12.1707ZM3.16667 5.17065V4.00399H11.3333V5.17065H3.16667ZM6.41 11.2723L9.86917 7.81315L9.25083 7.19482L6.41 10.0357L5.17917 8.80482L4.56083 9.42315L6.41 11.2723Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepEventAvailable);
export default __webpack_public_path__ + "static/media/StepEventAvailable.a484a7517f5fae55c55dd732a59ae607.svg";
export { ForwardRef as ReactComponent };